import { render, staticRenderFns } from "./FeedbackReply.vue?vue&type=template&id=d2d9dc60&"
import script from "./FeedbackReply.vue?vue&type=script&lang=js&"
export * from "./FeedbackReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports